import { ActionYd } from "./ActionYd.js";
import { Annotation } from "./Annotation.js";
import { Xiangji } from "./Xiangji.js";

export class AnnotationYd2 extends Annotation {
    constructor(args = {}) {
        super(args)

        this._data = args.data || null
        this._icon = args.icon
        this._iconActive = args.iconActive
        this.opacity = args.opacity || 1
        this.extraParams = args.extraParams

        this.XJdom = args.XJdom

        // 走基类 _setDomElement 而非直接赋值：替换后需按 _display 同步新元素的显隐，
        // 否则构造末尾 super 里的 display=false 只隐藏了被丢弃的基类元素（详见该方法注释）
        this._setDomElement($(`
                  <div class="yd-annotation-sxt2" oncontextmenu="return false;">
                    <div class="yd-sxt-img2"></div>
                    <div class="yd-sxt-img2-title">${this.extraParams.name || ''}</div>
                    <div class="yd-point-img"></div>
                  </div>
              `))
        this.imgdom = document.createElement('img')
        this.imgdom.src = this._icon
        this.imgdom.style.width = '16px'
        this.imgdom.style.height = '16px'
        this.ydsxtimg = this.domElement.find('.yd-sxt-img2')
        this.ydsxtimg.append(this.imgdom)
        this.ydsxtimgtitle = this.domElement.find('.yd-sxt-img2-title')
        //   this.ydannotationsxt = this.domElement.find('.yd-annotation-sxt2')

        this.pointImgStatus = false

        //   部件图
        //   this.pointImgdom = document.createElement('img')
        //   this.pointImg = args.pointImg || null
        //   if (this.pointImg) {
        //     this.pointImgdom.src = this.pointImg
        //   }
        //   this.pointImgdom.style.width = '100px'
        //   //   this.pointImgdom.style.height = '25px'

        this.ydpointimg = this.domElement.find('.yd-point-img')
        //   this.ydpointimg.append(this.XJdom)

        this.actions = this.actions.map((a) => {
            if (a instanceof ActionYd) {
                return a
            } else {
                return new ActionYd(a)
            }
        })

        for (let action of this.actions) {
            // this.elTitlebar.click(() => action.onclick({ annotation: this }))
            this.ydsxtimg.click(() => action.onclick(this))
        }

        this.domElement.mouseenter((e) => this.setHighlighted(true))
        this.domElement.mouseleave((e) => this.setHighlighted(false))

        this.domElement.on('touchstart', (e) => {
            this.setHighlighted(!this.isHighlighted)
        })
        //   }
    }
    showPointImg(data = true) {
        this.pointImgStatus = data ? true : false
        // dispose() 会把 ydpointimg 置空，本方法是公开的、移除后仍可能被业务侧调用
        if (!this.ydpointimg || !this.ydpointimg[0]) {
            return
        }
        if (data) {
            // 先销毁已有实例：否则重复展开会直接覆盖引用，旧相册的 DOM 与事件监听
            // 再没有任何引用能 destory 它。
            if (this.cameraDialog) {
                this.cameraDialog.destory()
                this.cameraDialog = null
            }
            // 挂载交给 Xiangji 自己（传 dom），与它内部的卸载对称
            this.cameraDialog = new Xiangji({ data, dom: this.ydpointimg })
            this.ydpointimg[0].style.display = 'block'
        } else {
            if (this.cameraDialog) {
                this.cameraDialog.destory()
                // 必须置空：否则 dispose() 的 if (this.cameraDialog) 仍为真，
                // 会对同一实例二次 destory
                this.cameraDialog = null
            }
            this.ydpointimg[0].style.display = 'none'
        }
    }
    setPointImg(url) {
        this.pointImg = url
        this.pointImgdom.src = url
    }

    setOpacity(opacity = 1) {
        if (this.ydsxtimg) {
            this.opacity = opacity
            if (opacity == 1) {
                //   this.domElement[0].style.padding = '10px'
                this.ydsxtimg[0].style.width = this.imgdom.style.width
                this.ydsxtimg[0].style.height = this.imgdom.style.height
                this.ydsxtimg[0].style.display = 'block'
            } else {
                this.domElement[0].style.padding = 0
                this.ydsxtimg[0].style.width = 0
                this.ydsxtimg[0].style.height = 0
                this.ydsxtimg[0].style.display = 'none'
            }
        }
    }

    setHighlighted(highlighted) {
        if (highlighted) {
            if (this.ydsxtimgtitle && this.opacity == 1) {
                this.ydsxtimgtitle[0].style.display = 'block'
            }
        } else {
            if (this.ydsxtimgtitle) {
                this.ydsxtimgtitle[0].style.display = 'none'
            }
        }

        this.isHighlighted = highlighted
    }

    dispose() {
        // 解绑点击事件
        if (this.ydsxtimg) {
            this.ydsxtimg.off()
        }
        // 销毁懒加载的 Xiangji 相册，避免相册 DOM/事件泄漏
        if (this.cameraDialog) {
            this.cameraDialog.destory()
            this.cameraDialog = null
        }
        this.imgdom = null
        this.ydsxtimg = null
        this.ydsxtimgtitle = null
        this.ydpointimg = null

        super.dispose()
    }
}